
namespace SP {
    export class DialogBox {
        static ZIndex = 10000000;
        container: HTMLElement;
        dialog: HTMLElement;
        text_container: HTMLElement;
        text: HTMLElement;
        footer_container: HTMLElement;

        constructor(hasCancel: boolean) {
            this.container = document.createElement("div");
            this.container.classList.add("sp_dialog_container");
            document.body.appendChild(this.container);


            this.dialog = document.createElement("div");
            this.dialog.classList.add("sp_dialog");
            this.container.appendChild(this.dialog);

            this.text_container = document.createElement("div");
            this.text_container.classList.add("text_container");
            this.dialog.appendChild(this.text_container);

            this.text = document.createElement("div");
            this.text.classList.add("content_inner");
            this.text_container.appendChild(this.text);

            this.footer_container = document.createElement("div");
            this.footer_container.classList.add("footer_container");
            this.dialog.appendChild(this.footer_container);



            //add button
            if (hasCancel) {
                var cancel_btn = document.createElement("div");
                cancel_btn.classList.add("cancel_btn");
                cancel_btn.innerHTML = `Cancel`;
                cancel_btn.addEventListener("click", () => {
                    this.pressCancel();
                });
                this.footer_container.appendChild(cancel_btn);
            }

            //add button
            var ok_btn = document.createElement("div");
            ok_btn.classList.add("ok_btn");
            ok_btn.innerHTML = `Ok`;
            ok_btn.addEventListener("click", () => {
                this.pressOk();
            });

            this.footer_container.appendChild(ok_btn);
        }

        resolveOnClose: (result: boolean) => void;

        async prompt(message: string, error: boolean): Promise<boolean> {
            DialogBox.ZIndex++;
            this.container.style.zIndex = DialogBox.ZIndex.toString();
            this.text.innerHTML = message;
            this.container.style.display = "flex";

            if (error) SP.Sounds.Error.play();
            else SP.Sounds.Notification.play();

            // Promise is created only for the close operation.
            return new Promise<boolean>((resolve, reject) => {
                this.resolveOnClose = resolve;
            });
            document.body.appendChild(this.container);
        }


        pressOk() {
            this.resolveOnClose(true);
            this.cleanup();
        }

        pressCancel() {
            this.resolveOnClose(false);
            this.cleanup();

        }
        cleanup() {
            this.container.remove();
        }
    }
}